import React from 'react';
import { Dropdown } from 'semantic-ui-react';
import { useIntl } from 'react-intl';

const QueryDictionariesDropdownItems = ({
  category,
  code,
  queryUUID,
  dictionaries,
  onChange,
}) => {
  const intl = useIntl();
  return (
    dictionaries.map((dictionary) => (
      <Dropdown.Item
        key={`query_dictionaries_dropdown_${dictionary.code}`}
        text={dictionary.name}
        value={dictionary.code}
        description={dictionary.primary ? intl.formatMessage({ id: 'dictionary.primary' }) : undefined}
        onClick={() => onChange(category, code, queryUUID, dictionary.code)}
      />
    ))
  );
};

export default QueryDictionariesDropdownItems;
